var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8748 9.50671V17.8749C17.8748 18.4219 17.6575 18.9465 17.2707 19.3333C16.8839 19.7201 16.3593 19.9374 15.8123 19.9374H6.18726C5.64025 19.9374 5.11564 19.7201 4.72885 19.3333C4.34205 18.9465 4.12476 18.4219 4.12476 17.8749V4.12488C4.12476 3.57787 4.34205 3.05326 4.72885 2.66647C5.11564 2.27968 5.64025 2.06238 6.18726 2.06238H10.4304C10.795 2.06243 11.1446 2.20725 11.4024 2.465L17.4721 8.53476C17.7299 8.79256 17.8747 9.14217 17.8748 9.50671Z",
    stroke: "#292A3D",
    strokeWidth: 1.13514,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8748 9.50671V17.8749C17.8748 18.4219 17.6575 18.9465 17.2707 19.3333C16.8839 19.7201 16.3593 19.9374 15.8123 19.9374H6.18726C5.64025 19.9374 5.11564 19.7201 4.72885 19.3333C4.34205 18.9465 4.12476 18.4219 4.12476 17.8749V4.12488C4.12476 3.57787 4.34205 3.05326 4.72885 2.66647C5.11564 2.27968 5.64025 2.06238 6.18726 2.06238H10.4304C10.795 2.06243 11.1446 2.20725 11.4024 2.465L17.4721 8.53476C17.7299 8.79256 17.8747 9.14217 17.8748 9.50671Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.13514,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.40625V7.5625C11 7.92717 11.1449 8.27691 11.4027 8.53477C11.6606 8.79263 12.0103 8.9375 12.375 8.9375H17.5312M7.5625 12.375H14.4375M7.5625 15.8125H14.4375",
    stroke: "#292A3D",
    strokeWidth: 1.13514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.40625V7.5625C11 7.92717 11.1449 8.27691 11.4027 8.53477C11.6606 8.79263 12.0103 8.9375 12.375 8.9375H17.5312M7.5625 12.375H14.4375M7.5625 15.8125H14.4375",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.13514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.c323eea6181469a4179bef871f9d79e9.svg";
export { ForwardRef as ReactComponent };